export const arraySort = (arr, sortKey, sortOrder) => {
  return arr.sort((firstObj, secndObj) => {
    return sortOrder === "asc" ? firstObj[sortKey] - secndObj[sortKey] : secndObj[sortKey] - firstObj[sortKey];
  });
};
